var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container list" }, [
    _c("div", { staticClass: "title" }, [
      _vm._v("\n        募集中のフアンド\n    "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "box-title" }, [
        _vm._v("\n            匿名組合契約型\n        "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "title1" }, [
        _vm._v(
          "\n            インドネシア・マイクロファイナンス第1号\n        "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "title2" }, [
        _vm._v("\n            目標利回り：７％／年\n        "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "title2" }, [
        _vm._v("\n            運用期間：１８０日\n        "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "title2" }, [
        _vm._v(
          "\n            ファンド名：インドネシア・マイクロファイナンス第1号（匿名組合契約型）\n        "
        ),
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "arrow",
        attrs: { src: require("./img/arrow.svg"), alt: "" },
        on: { click: _vm.onGo },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }